<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="
      cn(
        'group text-l-medium text-black-white flex items-center justify-center cursor-pointer ',
        props.class,
      )
    "
    @click="handleBack"
  >
    <Icon
      icon="Direction-Wireframe-Left2"
      class="size-6 transition-colors group-hover:text-blue-dark-hover group-active:text-brand-blue1"
    ></Icon>
    <span class="transition-colors group-hover:text-blue-dark-hover group-active:text-brand-blue1">
      {{ $t('common.backButton') }}
    </span>
  </Primitive>
</template>

<script setup lang="ts">
  import { Icon } from '@rapoo/element'
  import { type HTMLAttributes } from 'vue'
  import { Primitive, type PrimitiveProps } from 'reka-ui'
  import { cn } from '@rapoo/element'
  import { useRouter } from 'vue-router'

  interface Props extends PrimitiveProps {
    class?: HTMLAttributes['class']
  }
  const props = withDefaults(defineProps<Props>(), {
    as: 'button',
  })

  const router = useRouter()
  const handleBack = () => {
    router.back()
  }
</script>
